<template>
  <div>
    <div id="billing-pref" class="mt-4">
      <div class="row">
        <div class="col-md-6">
          <h4 class="mt-4 pt-2">Billing Preference</h4>
          <label class="radio-head">
            <input type="radio" name="billing-pref" @input="setAutoPay(true)" :checked="form_data.auto_pay">
            <span>Auto-bill monthly</span>
          </label>
          <label class="radio-head">
            <input type="radio" name="billing-pref" @input="setAutoPay(false)" :checked="!form_data.auto_pay">
            <span>Manual payment</span>
          </label>
        </div>
        <div class="col-md-6" v-if="showBillingAddress">
          <h4 class="mt-4 pt-2">Billing Address</h4>
          <label class="radio-head" id="billing-addr-same">
            <input type="radio" name="billing-addr-same" @input="setCopyAddress(true)" :checked="copyAddress">
            <span>{{ addressString }}</span>
          </label>
          <label class="radio-head">
            <input type="radio" name="billing-addr-same" id="different-billing-addr" @input="setCopyAddress(false)" :checked="copyAddress === false">
            <span>Enter new address</span>
          </label>
        </div>
      </div>
      <transition v-on:enter="scrolldown('revio-address-nptf')">
        <div v-show="showBillingAddress && (copyAddress !== null) && !copyAddress" id="revio-address-nptf">
          <revio-address v-model="form_data.billing_address" @form-state="x => address_valid = x" :company="false" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import logger from "../lib/logger";
  import RevioAddress from "./RevioAddress.vue";
  import helpers from "../lib/helpers";

  export default {
    components: {RevioAddress},
    data() {
      return {
        scrolldown: helpers.scrolldown,
        address_valid: false,
        address_string_length: 20,
        form_data: {
          alternate_billing_address: null,
          auto_pay: true,
          billing_address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            zip_code: '',
            zip_ext: '',
            fname: this.firstName,
            lname: this.lastName,
            mnami: '',
            cmp_name: ''
          },
        }
      }
    },

    props: {
      showBillingAddress: {
        type: Boolean,
        required: false,
        default: false
      },
      firstName: {
        type: String,
        required: false,
        default: ''
      },
      lastName: {
        type: String,
        required: false,
        default: ''
      },
      formattedAddress: {
        type: String,
        required: false,
        default: ''
      }
    },

    computed: {
      copyAddress() {
        if (this.form_data.alternate_billing_address === null) {
          return null;
        }
        return !this.form_data.alternate_billing_address;
      },
      addressString() {
        let address_string = this.formattedAddress;
        return address_string.length <= this.address_string_length ? address_string : address_string.substring(0, this.address_string_length) + '...';
      },
      addressIsValid () {
        return this.address_valid;
      },
      formDataValid() {
        return (this.copyAddress !== null) && (this.copyAddress || this.addressIsValid);
      },
      formData () {
        return this.form_data;
      }
    },

    methods: {
      setAutoPay(auto_pay) {
        this.form_data.auto_pay = auto_pay;
      },
      setCopyAddress(value) {
        logger.debug('set copy address', value)
        this.form_data.alternate_billing_address = !value;
      },
    },

    watch: {
      formData: {
        handler(new_val) {
          this.$emit('input', new_val);
        },
        deep: true
      },
      formDataValid(new_val){
        this.$emit('form-state', new_val);
        this.$emit(new_val ? 'form-valid' : 'form-invalid');
      },
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// NewPaymentTypeForm.vue?df391104